import { Pipe, PipeTransform } from '@angular/core';
import { TipoVariacaoTabelaDePreco } from 'src/app/core/models/provedor/TipoVariacaoTabelaDePreco';

@Pipe({
  name: 'tipoVariacao',
})
export class TipoVariacaoPipe implements PipeTransform {
  transform(value: TipoVariacaoTabelaDePreco): string {
    const labels = {
      1: 'Faixa Etária',
      2: 'Faixa Salarial',
      3: 'Valor Mensal',
      4: 'Valor Diário',
    };

    return labels[value] || labels['1'];
  }
}
